import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import * as firebase from "firebase";

Vue.config.productionTip = false;

// Initialize Firebase
var config = {
  apiKey: "AIzaSyDBc0-Ldo8mtXY78N7NQbAIFVgv5Uj7Kg8",
  authDomain: "vue-pwa-tutorial.firebaseapp.com",
  databaseURL: "https://vue-pwa-tutorial.firebaseio.com",
  projectId: "vue-pwa-tutorial",
  storageBucket: "vue-pwa-tutorial.appspot.com",
  messagingSenderId: "630674987445"
};
firebase.initializeApp(config);

// Retrieve Firebase Messaging object.
const messaging = firebase.messaging();

// Add the public key generated from the console here.
messaging.usePublicVapidKey("BLJO3qKxfbaynTpy5PujdrQ4Ch7GpNH5vxHtU49uZ0JCiJg7clnYbD71gKF9T8SV7iqLaoQXN6nvMxcuHfj7kdQ");

messaging.requestPermission().then(() => {
  console.log('Notification permission granted.');
  messaging.getToken().then((token) => {
    console.log(token);
  })
}).catch((err) => {
  console.log('Unable to get permission to notify.', err);
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
